import api from '../../services/api';

/**
 * The admins of the platform, paginated, for the staff's table.
 *
 * Staff only: the view answers 403 to anyone else, even to an admin with its
 * own profile. `search` matches first name, last name, email and rut.
 *
 * @param {{search?: string, page?: number, page_size?: number}} params
 */
export const getStaffAdminsRequest = async (params) => {
  return await api.get('admins/staff/list/', { params });
};

/** One admin, with its plan, country and user. Staff only. */
export const getStaffAdminRequest = async (adminId) => {
  return await api.get(`admins/staff/${adminId}/`);
};

/**
 * Turns one switch of an admin's plan on or off.
 *
 * The body carries a single key of a single group — `{ addons: { api_access:
 * true } }` — because the backend merges it into the stored JSON. Sending the
 * whole object would overwrite whatever another tab changed in between.
 *
 * @param {number|string} adminId
 * @param {'seller_channels'|'addons'} field
 * @param {string} key
 * @param {boolean} value
 */
export const updateStaffAdminPlanRequest = async (adminId, field, key, value) => {
  return await api.patch(`admins/staff/${adminId}/plan/`, { [field]: { [key]: value } });
};

/**
 * Every admin, flat, for the selects that have to name one.
 *
 * A different endpoint from the table's: this one is the whole roster and it is
 * what the zone form already uses. It answers to any authenticated user, which
 * is a backend problem of its own; the front only asks for it as staff.
 */
export const getAdminOptionsRequest = async () => {
  return await api.get('admins/list/');
};
